import React from "react";
import { NavLink as RouterNavLink } from "react-router-dom";
interface BottomBarComponentProps {
  // Add props here
}

const BottomBarComponent: React.FC<BottomBarComponentProps> = () => {
  return (
    <div className="w-full px-3 pt-2 bg-white shadow-md border-t fixed bottom-0 pb-3.5">
      <div className="flex justify-between items-center w-full">
        <NavLink name="Chuyến đi" url="trips" icon="fa-suitcase-rolling" />
        <NavLink name="Khách hàng" url="customers" icon="fa-users" />
        <NavLink
          name="Lịch vạn niên"
          url="calendars"
          icon="fa-calendar"
        />
        <NavLink name="Lịch sử" url="histories" icon="fa-clock" />
      </div>
    </div>
  );
};
interface INavLinkProps {
  icon?: string;
  name: string;
  url: string;
  // action:()=>void
}

const NavLink: React.FC<INavLinkProps> = ({ icon, name, url }) => {
  return (
    <RouterNavLink
      to={url}
      // onClick={()=>}
      className={({ isActive }) =>
        `flex flex-col items-center w-[85px] rounded-md py-1 px-2  ${
          isActive
            ? " text-red-600"
            : "text-gray-400"
        }`
      }
    >
      <i className={`fa-solid text-[20px] ${icon}`} />
      <p className="text-[13px] whitespace-nowrap mt-1">{name}</p>
    </RouterNavLink>
  );
};
export default BottomBarComponent;
